import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { AUTH_INITIAL_STATE } from "../constants/authSlice.constants";
import { IAuthPayload } from "../types/authSlice.types";

export const loginUser = createAsyncThunk(
    "auth/login",
    async (requestData: IAuthPayload) => {
        const response: any = await axios.post("/Auth/Login", requestData);
        return response.data || response?.response?.data;
    },
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
    const response = await axios.post("/Auth/LogOff");
    return response.data;
});

export const verifyNIN = createAsyncThunk(
    "auth/verifyNIN",
    async (data: { nin: string }) => {
        const response = await axios.post("/Auth/VerifyNIN", data);
        return response.data;
    },
);

export const authSlice = createSlice({
    name: "auth",
    initialState: AUTH_INITIAL_STATE,
    reducers: {
        setUserData(state, payload) {
            state.data = payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(loginUser.pending, state => {
                state.loading = "pending";
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = "succeeded";
                state.data = action.payload;
                state.error = null;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = "failed";
                state.error = action.error.message || "An error occurred.";
            })
            .addCase(logoutUser.pending, state => {
                state.loading = "pending";
            })
            .addCase(logoutUser.fulfilled, state => {
                state.loading = "succeeded";
                state.error = null;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.loading = "failed";
                state.error = action.error.message || "An error occurred.";
            })
            .addCase(verifyNIN.pending, state => {
                state.loading = "pending";
            })
            .addCase(verifyNIN.fulfilled, state => {
                state.loading = "succeeded";
                state.error = null;
            })
            .addCase(verifyNIN.rejected, (state, action) => {
                state.loading = "failed";
                state.error = action.error.message || "An error occurred.";
            });
    },
});

export const { setUserData } = authSlice.actions;

export default authSlice.reducer;
